module.exports = __webpack_public_path__ + "static/media/Sass_Logo_Color.e0f651ac.svg";